import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/custom-style.css'
import './assets/css/animate.css'
// import './assets/js/animate.js'

import { VBScrollspyPlugin } from 'bootstrap-vue'

Vue.use(VBScrollspyPlugin)
Vue.use(BootstrapVue)
Vue.use(axios)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
